import { useMemo } from 'react'
import { IntegrationServiceId } from '../../common/integrations'
import { type CapabilityState } from '../../models/Onboarding'
import { selectAccountId } from '../auth/authSlice'
import { useAppSelector } from '../hooks'
import { useGetMeQuery } from '../user/user'
import { useIntegrations } from '../../views/Integration/useIntegrations'

const ZOOM_SOURCES = [IntegrationServiceId.ZOOM]

export const useZoomCapability = (): CapabilityState & { isLoading: boolean } => {
  const accountId = useAppSelector(selectAccountId)
  const { data: me, isLoading: isMeLoading } = useGetMeQuery({ accountId })
  const { isIntegrationAllowed, isLoading: isIntegrationsLoading } = useIntegrations()

  const connectedIds = useMemo(() => new Set(me?.integrations?.map((i) => i.serviceId) ?? []), [me])

  return useMemo<CapabilityState & { isLoading: boolean }>(() => {
    const allowedServiceIds = ZOOM_SOURCES.filter((id) => isIntegrationAllowed(id))
    const isAllowed = allowedServiceIds.length > 0
    const isFulfilled = ZOOM_SOURCES.some((id) => connectedIds.has(id))
    const connectedIntegrations = ZOOM_SOURCES.filter((id) => connectedIds.has(id))
    return {
      isAllowed,
      isFulfilled,
      allowedServiceIds,
      connectedIntegrations,
      connectedWithoutSync: [],
      isLoading: isMeLoading || isIntegrationsLoading,
    }
  }, [isIntegrationAllowed, connectedIds, isMeLoading, isIntegrationsLoading])
}
